import { createAsyncAction } from "./utils";
export var verifyCaptcha = createAsyncAction('verifyCaptcha', function (captchaValue) {
  var showMessages = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return {
    meta: {
      captchaValue: captchaValue,
      showMessages: showMessages
    },
    makeRequest: function makeRequest(state, opts) {
      return opts.IdentitySDK.verifyGoogleRecaptcha(captchaValue);
    }
  };
});